export interface TipTapNode {
  type?: string;
  attrs?: Record<string, unknown>;
  content?: TipTapNode[];
  marks?: { type: string; attrs?: Record<string, unknown> }[];
  text?: string;
}

export interface TipTapRenderOptions {
  color: string;
  primary: string;
  radius: number;
}

export function collectText(nodes: TipTapNode[]): string {
  let output = '';
  for (const node of nodes) {
    if (node.text) output += node.text;
    if (node.content) output += collectText(node.content);
  }
  return output;
}
